export * from './switch.component'